


import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { useMediaQuery } from '@mui/system'
import AddRefer from '../../Components/ReferralUser/AddRefer'
import ReferList from '../../Components/ReferralUser/ReferList'
import ReferRoutesAccess from './ReferRoutesAccess'
import ReferralUserSidebar from '../../Container/ReferralUser/ReferralUserSidebar'


const ReferRoutes = () => {
  const isLargeScreen = useMediaQuery("(min-width:1441px)");

  return (
    <div>
          <div>
      <ReferralUserSidebar />
      <div style={{ marginLeft: isLargeScreen ? '250px' : '0', flexGrow: 1, padding: "10px" }}>

      <Routes>
          <Route path="/add-referral" element={<ReferRoutesAccess element={<AddRefer />} />}/>
          <Route path="/my-referral" element={<ReferRoutesAccess element={<ReferList />} />}/>
      </Routes>
    </div>
    </div>
    </div>
  )
}

export default ReferRoutes